export default class NovoVendedor {
  constructor(
    cpf = "",
    nome = "",
    dtNascimento = "",
    telefone1 = "",
    telefone2 = "",
    rg = "",
    praca = "",
    cep = "",
    cidade = "",
    bairro = "",
    rua = "",
    numero = "",
    situacao = "",
    uf = ""
  ) {
    this.cpf = cpf
    this.nome = nome
    this.dataNascimento = dtNascimento
    this.telefone1 = telefone1
    this.telefone2 = telefone2
    this.rg = rg
    this.codPraca = praca
    this.cep = cep
    this.cidade = cidade
    this.bairro = bairro
    this.rua = rua
    this.numero = numero
    this.uf = uf
    this.situacao = situacao
  }
}
